module.exports = __webpack_public_path__ + "img/mb-advantage-5.36d5da31.png";